const { postData, getData } = require('js/api/getdata').default
/**
 * 获取eod下载路径
 */
export const getEodUrl = (metaData) => {
  const deliveryCode = metaData[0].delivery_code
  let neids = ''
  metaData.forEach((item) => {
    neids += `neids=${item.neid}&`
  })
  const url = `/${deliveryCode}?${neids}`
  return getData('getEodUrl', { url })
}
// 下载校验文件数量大小权限
export const checkFile = (metaData) => {
  const deliveryCode = metaData[0].delivery_code
  const neids = []
  metaData.forEach((item) => {
    neids.push(item.neid)
  })
  const params = {
    deliveryCode,
    neids,
    arrayFormat: true,
  }
  return new Promise((resolve) => {
    postData('checkFile', params).then((res) => {
      resolve(res)
    }).catch((error) => {
      resolve(error.response)
    })
  })
}
// 校验下载次数
export const checkDownloadLimit = (metaData) => {
  const deliveryCode = metaData[0].delivery_code
  const url = `/${deliveryCode}`
  return getData('downloadLimit', { url })
}
/*
* isWhereFromSetPythType 日志中各个空间对应的参数值
* @params {String} pathType - 空间类型
* @return {Number}
* */
const isWhereFromSetPythType = (pathType) => {
  switch (pathType) {
    case 'ent':
      return 1
    case 'self':
      return 2
    case 'share_out':
      return 3
    case 'share_in':
      return 4
    default:
      return 0
  }
}
/*
* sendLogBuryingPointMethods 记录日志
* @params {Object}
* */
export const sendLogBuryingPointMethods = (params) => {
  const {
    category, action, nsid, pathType,
    neid, entityStr1, entityStr2, entityStr3,
    type,
  } = params
  const postDataForLog = {
    category,
    action,
    nsid,
    pathType: isWhereFromSetPythType(pathType),
  }
  if (neid) {
    postDataForLog.neid = neid
  }
  if (entityStr1) {
    postDataForLog.entityStr1 = entityStr1
  }
  if (entityStr2) {
    postDataForLog.entityStr2 = entityStr2
  }
  if (entityStr3) {
    postDataForLog.entityStr3 = entityStr3
  }
  if (type && type === 'batch') { // 批量创建日志
    postDataForLog.arrayFormat = true
    return postData('batchLogging', postDataForLog)
  }
  return postData('log', postDataForLog) // 单个日志
}
